export default [
  {
    path: '/history/phone',
    name: 'HistoryPhoneList',
    component: () => import('@/views/history/PhoneList.vue')
  },
  {
    path: '/history/complaint',
    name: 'HistoryComplaintList',
    component: () => import('@/views/history/ComplaintList.vue')
  }
];
